// extracted by mini-css-extract-plugin
export default {"ModelExpression":"ModelHairstyle_ModelExpression__ICjFt","Item":"ModelHairstyle_Item__LMGER","Active":"ModelHairstyle_Active__grdP0","titleText":"ModelHairstyle_titleText__eskI5"};